import React from 'react';
import { cn } from '@/lib/utils';

// Phone Layout Components
interface PhoneLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Main phone container - card wrapper with consistent sizing
 */
export const PhoneLayout: React.FC<PhoneLayoutProps> = ({ children, className }) => {
  return (
    <div className={cn(
      "w-full max-w-sm p-2 sm:p-4 mx-auto rounded-3xl flex flex-col relative",
      "h-full justify-center",
      className
    )}>
      {children}
    </div>
  );
};

interface PhoneHeaderProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Header section - status, badges, etc.
 */
export const PhoneHeader: React.FC<PhoneHeaderProps> = ({ children, className }) => (
  <div className={cn("mb-2 short:mb-1", className)}>
    {children}
  </div>
);

interface PhoneDisplayProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Phone number display area
 */
export const PhoneDisplay: React.FC<PhoneDisplayProps> = ({ children, className }) => (
  <div className={cn("bg-muted rounded-2xl p-3 short:p-2 mb-3 short:mb-2 border", className)}>
    {children}
  </div>
);

interface PhoneKeypadProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Keypad container - grows to fill available space
 */
export const PhoneKeypad: React.FC<PhoneKeypadProps> = ({ children, className }) => (
  <div className={cn("flex-1 flex items-center justify-center", className)}>
    {children}
  </div>
);

interface PhoneActionsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Action buttons section
 */
export const PhoneActions: React.FC<PhoneActionsProps> = ({ children, className }) => (
  <div className={cn("mt-4", className)}>
    {children}
  </div>
);
